export default "__VITE_ASSET__Crh1RxhZ__"